const tipoEnderecoList = [
    {
        id: 'R', //  HARDCODE.idTipoEnderecoResidencial
        descricao: 'Residencial',
        ordem: 10,
    },
    {
        id: 'C',
        descricao: 'Comercial',
        ordem: 20,
    },
]

export default tipoEnderecoList